import { render, staticRenderFns } from "./System.vue?vue&type=template&id=13723f81&scoped=true"
import script from "./System.vue?vue&type=script&lang=js"
export * from "./System.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13723f81",
  null
  
)

export default component.exports